import {Tag} from 'platform/components';
import {Box, Center, Clickable, HStack, Icon, Text} from 'platform/foundation';

import {useState} from 'react';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

interface EditableFilterTagProps extends TestIdProps {
  label: string;
  onDelete: () => void;
  onClick?: () => void;
}

export function EditableFilterTag(props: EditableFilterTagProps) {
  const [hoveredAction, setHoveredAction] = useState<'edit' | 'remove' | null>(null);

  if (!props.onClick) {
    return (
      <Tag
        label={props.label}
        onDelete={props.onDelete}
        colorScheme="blue"
        data-testid={props['data-testid']}
      />
    );
  }

  return (
    <Box borderRadius="small" backgroundColor="palettes.blue.70.100">
      <HStack align="center">
        <Clickable
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              props.onClick?.();
            }
          }}
          aria-label={`${i18n.t('general.actions.edit')}: ${props.label}`}
          onClick={props.onClick}
          onMouseEnter={() => setHoveredAction('edit')}
          onMouseLeave={() => setHoveredAction(null)}
          data-testid={suffixTestId('edit', props)}
        >
          <Box
            paddingHorizontal={2}
            backgroundColor={hoveredAction === 'edit' ? 'palettes.blue.80.100' : undefined}
            borderTopLeftRadius="small"
            borderBottomLeftRadius="small"
          >
            <Center height={6}>
              <Text size="small" color="white">
                {props.label}
              </Text>
            </Center>
          </Box>
        </Clickable>
        <Clickable
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              props.onDelete();
            }
          }}
          aria-label={`${i18n.t('general.actions.remove')}: ${props.label}`}
          onClick={props.onDelete}
          onMouseEnter={() => setHoveredAction('remove')}
          onMouseLeave={() => setHoveredAction(null)}
          data-testid={suffixTestId('tagIcon', props)}
        >
          <Box
            backgroundColor={hoveredAction === 'remove' ? 'palettes.blue.80.100' : undefined}
            borderLeft="1px solid"
            borderColor="palettes.blue.60.100"
            borderTopRightRadius="small"
            borderBottomRightRadius="small"
          >
            <Center width={6} height={6}>
              <Icon value="navigation/close" size={4} color="palettes.white.10.100" />
            </Center>
          </Box>
        </Clickable>
      </HStack>
    </Box>
  );
}
